module.exports = __webpack_public_path__ + "img/2024-02-13b_2.de21db5b.jpg";